// Drop safety levels from the after-drop gallons (see Drop Safety Rules).
export const WATER_KEY = "fhp-water-limit";
export const waterLimit = () => { const v = parseFloat(localStorage.getItem(WATER_KEY)); return v > 0 ? v : 1; };

export function dropSafety(s, r) {
  // Use the same capacity the prediction used (station chart or tank shape) so the checks agree.
  const cap = r.cap90 > 0 ? r.cap90 / 0.9 : s.capacity;
  const after = r.finalGallons;
  const pct = cap > 0 ? (after / cap) * 100 : 0;
  const room90 = Math.max(0, Math.floor(cap * 0.9 - r.startGallons + 1e-6));
  const base = { pct, room90, after, over95: Math.round(after - cap * 0.95), overflow: Math.round(after - cap) };
  if (!(s.dropGallons > 0)) return { ...base, level: "none" };
  if (pct > 100.0001) return { ...base, level: "overflow" };
  if (pct >= 95) return { ...base, level: "over95" };
  if (pct > 90.0001) return { ...base, level: "over90" };
  return { ...base, level: "ok" };
}

export const isOver90 = (lv) => lv === "over90" || lv === "over95" || lv === "overflow";
// What the status pill shows: the most serious problem first (a wrong product only beats "ok").
export const shownLevel = (sf, mismatch) => (mismatch && sf.level === "ok" ? { ...sf, level: "mismatch" } : sf);
